import { useState } from "react";

const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  theme = "light",
  accentColor = "#6366f1",
  size = "default", // "small" | "default"
  label,
  isRTL = false,
}) => {
  const [hovered, setHovered] = useState(false);

  const sizes = size === "small"
    ? { track: { w: 36, h: 20 }, thumb: 14, offset: 3 }
    : { track: { w: 44, h: 24 }, thumb: 18, offset: 3 };

  const trackStyle = {
    position: "relative",
    width: sizes.track.w,
    height: sizes.track.h,
    borderRadius: sizes.track.h,
    background: checked
      ? accentColor
      : theme === "dark"
        ? "rgba(100, 116, 139, 0.5)"
        : "rgba(203, 213, 225, 0.9)",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    opacity: disabled ? 0.5 : 1,
    flexShrink: 0,
    boxShadow: checked
      ? `0 0 0 ${hovered && !disabled ? "3px" : "0px"} ${accentColor}33, inset 0 1px 2px rgba(0,0,0,0.1)`
      : `inset 0 1px 3px rgba(0,0,0,${theme === "dark" ? "0.3" : "0.12"})`,
    border: checked
      ? `1.5px solid ${accentColor}`
      : theme === "dark"
        ? "1.5px solid rgba(148,163,184,0.2)"
        : "1.5px solid rgba(203,213,225,0.6)",
  };

  const thumbStyle = {
    position: "absolute",
    top: sizes.offset,
    left: checked
      ? sizes.track.w - sizes.thumb - sizes.offset - 3
      : sizes.offset,
    width: sizes.thumb,
    height: sizes.thumb,
    borderRadius: "50%",
    background: "#ffffff",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2), 0 1px 2px rgba(0,0,0,0.12)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    transform: hovered && !disabled ? "scale(1.1)" : "scale(1)",
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexDirection: "row",
      }}
    >
      <div
        style={trackStyle}
        onClick={() => {
          if (!disabled && onChange) {
            onChange({ target: { checked: !checked } });
          }
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            if (!disabled && onChange) {
              onChange({ target: { checked: !checked } });
            }
          }
        }}
      >
        <div style={thumbStyle} />
      </div>
      {label && (
        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: checked
              ? accentColor
              : theme === "dark"
                ? "rgba(226,232,240,0.7)"
                : "rgba(100,116,139,0.9)",
            transition: "color 0.2s ease",
            userSelect: "none",
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
